import { V3ToggleSwitch } from "../ToggleSwitch/V3ToggleSwitch"
import { V3SubtitleMedium } from "../Typography"
import { LPToggleTittle, V3LightPanelItem, V3LightPanelWrapper } from "./V3LightPanel.styles"

import type { JSX } from "react";

interface V3LightPanelProps {
    panels: JSX.Element[],
    withToggle?: boolean,
    toggleValue?: boolean,
    toggleTitle?: string,
    onToggleChange?: () => void,
    hideMobileFrame?: boolean,
    minHeight?: string,
    fullHeight?: boolean,
}

export const V3LightPanel = ({ panels, withToggle = false, toggleValue, toggleTitle, onToggleChange, hideMobileFrame, minHeight, fullHeight }: V3LightPanelProps) => {
    return <V3LightPanelWrapper $hideMobileFrame={hideMobileFrame} $minHeight={minHeight} $fullHeight={fullHeight}>
        {
            (withToggle || toggleValue) && <LPToggleTittle>
                <div>
                    <V3SubtitleMedium>{toggleTitle}</V3SubtitleMedium>
                </div>
                <div>
                    <V3ToggleSwitch checked={toggleValue} onChange={onToggleChange} />
                </div>
            </LPToggleTittle>
        }
        {
            (!withToggle || toggleValue) && panels.map((panel, index) => <V3LightPanelItem key={index} $fullHeight={fullHeight}>
                {panel}
            </V3LightPanelItem>)
        }
    </V3LightPanelWrapper>
}